import React, { useEffect, useState } from 'react';
import { Header } from 'react-frontier';
import { useTranslation } from 'react-i18next';

interface NotFoundProps{
	code?: string,
	text?: string,
}

var NotFound = (props: NotFoundProps)=>{
	var { t } = useTranslation();
	return <Header
		text={props.code || '404'}
		subtext={t('common.page_notfound') || props.text}
		style={{ fontSize: 100 }}
		subheaderStyle={{ fontSize: 20 }}
		containerStyle={{ marginTop: 20 }}
	/>
}

export default NotFound;